import React from "react";
import { TextBlock, RectShape } from "react-placeholder/lib/placeholders";

import "react-placeholder/lib/reactPlaceholder.css";

export default function Placeholder(props) {
  const renderItem = () => {
    const items = [1, 2, 3, 4, 5, 6];

    return items.map(item => (
      <div key={item} style={{ width: "calc(100% / 3 - 30px)", margin: 15 }}>
        <RectShape color="#e0e0e0" style={{ height: 400, marginBottom: 20 }} />
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <TextBlock
            style={{ width: "calc(100% - 60px)" }}
            rows={2}
            color="#e0e0e0"
          />
          <RectShape
            style={{ width: 40, height: 40, marginRight: 0 }}
            color="#e0e0e0"
          />
        </div>
      </div>
    ));
  };

  return (
    <div
      style={{ display: "flex", flexWrap: "wrap", margin: -15, marginTop: 0 }}
    >
      {renderItem()}
    </div>
  );
}
